/* Booster Lite — personalizador 3D · Pokeremmicias */
(() => {
  const root = document.querySelector('[data-pkrm-bl]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-pkrm-bl-config]').textContent);
  const mv = root.querySelector('model-viewer');
  const form = root.querySelector('form');
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const T = cfg.i18n || {};
  const EN = cfg.lang === 'en';
  const cname = (c) => (EN && c.en ? c.en : c.name);
  const fmt = (s, o) => s.replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));
  const TC_NAMES = (T.tc_names || '').split(',');

  // Zone canvases (px) keep the printed aspect ratio of each zone (mm)
  const ZONES = {
    Trasera:    { w: 1024, h: 1454, fit: 'cover',   side: 'back' },   // 82 x 116.5 mm
    // Cabezal: printed under the key-ring hole, ~10 x 10 mm inside a 20 x 20 mm UV square
    Cabezal:    { w: 512,  h: 512,  fit: 'contain', side: 'front', box: [126, 247, 260, 260] },
    // Esquinas: ~7.5 x 7.5 mm centred in the 10 x 10 mm corner zone
    EsquinaIzq: { w: 512,  h: 512,  fit: 'contain', side: 'front', box: [64, 64, 384, 384] },
    EsquinaDer: { w: 512,  h: 512,  fit: 'contain', side: 'front', box: [64, 64, 384, 384] },
    // Nombre: the zone spans the whole bottom bar (80 x 6.6 mm); the text sits in a 30 mm slot left / centre / right
    Nombre:     { w: 3200, h: 264,  fit: 'text',    side: 'front' }
  };
  const FONTS = [
    ['Alfa Slab One', 'Alfa Slab One', 400],
    ['Anton', 'Anton', 400],
    ['Bangers', 'Bangers', 400],
    ['Bebas Neue', 'Bebas Neue', 400],
    ['Black Ops One', 'Black Ops One', 400],
    ['Lobster', 'Lobster', 400],
    ['Luckiest Guy', 'Luckiest Guy', 400],
    ['Montserrat', 'Montserrat', 800],
    ['Pacifico', 'Pacifico', 400],
    ['Permanent Marker', 'Permanent Marker', 400],
    ['Poppins', 'Poppins', 700],
    ['Press Start 2P', 'Press Start 2P', 400],
    ['Righteous', 'Righteous', 400],
    ['Russo One', 'Russo One', 400]
  ];
  const BALL = 'data:image/png;base64,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';
  const TEXT_COLORS = [
    ['Rosa', '#F7A8C9'], ['Blanco', '#FFFFFF'], ['Negro', '#111111'], ['Rojo', '#E0312B'],
    ['Amarillo', '#FFD400'], ['Azul', '#2F6BFF'], ['Morado', '#6B4DA1'], ['Verde', '#2FAE5A']
  ];

  const state = {
    line: 'PLA Basic',
    color: null,
    uploads: {},           // zone -> File
    name: '',
    font: FONTS[0][0],
    textColor: TEXT_COLORS[0],
    outline: 'Blanco',
    namePos: 'Izquierda',
    sameCorners: true,
    backFit: { zoom: 100, x: 0, y: 0 },
    headSize: 100,
    ready: false
  };

  /* ---------- helpers ---------- */
  const err = $('[data-error]');
  const showError = (msg) => { err.textContent = msg; err.hidden = !msg; if (msg) err.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); };
  const nextFrame = () => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
  const mat = (name) => mv.model && mv.model.getMaterialByName(name);

  async function isPng(file) {
    const head = new Uint8Array(await file.slice(0, 8).arrayBuffer());
    return [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a].every((b, i) => head[i] === b);
  }

  function canvasToUrl(canvas) {
    return new Promise((res) => canvas.toBlob((b) => res(URL.createObjectURL(b)), 'image/png'));
  }

  async function fitImage(source, zone) {
    const z = ZONES[zone];
    const bmp = source instanceof Blob ? await createImageBitmap(source) : source;
    const c = document.createElement('canvas');
    c.width = z.w; c.height = z.h;
    const ctx = c.getContext('2d');
    let [bx, by, bw, bh] = z.box || [0, 0, z.w, z.h];
    if (zone === 'Cabezal') {   // customer size: below 100% shrinks around the centre; above, grows upwards over the ring hole (bottom edge stays just above the card window)
      const f = state.headSize / 100, side = 260 * f;
      bx = 256 - side / 2; bw = bh = side;
      by = f <= 1 ? 377 - side / 2 : 507 - side;
    }
    let s = z.fit === 'cover' ? Math.max(bw / bmp.width, bh / bmp.height) : Math.min(bw / bmp.width, bh / bmp.height);
    let ox = 0, oy = 0;
    if (zone === 'Trasera') {   // customer zoom / position (100% = fills the whole back, edge to edge)
      s *= state.backFit.zoom / 100;
      ox = (state.backFit.x / 100) * bw;
      oy = (state.backFit.y / 100) * bh;
    }
    const dw = bmp.width * s, dh = bmp.height * s;
    ctx.drawImage(bmp, bx + (bw - dw) / 2 + ox, by + (bh - dh) / 2 + oy, dw, dh);
    const info = { w: bmp.width, h: bmp.height };
    if (source instanceof Blob && bmp.close) bmp.close();
    return { url: await canvasToUrl(c), info };
  }
  async function hasTransparency(file) {
    const bmp = await createImageBitmap(file);
    const c = document.createElement('canvas');
    c.width = 64; c.height = 64;
    const ctx = c.getContext('2d');
    ctx.drawImage(bmp, 0, 0, 64, 64);
    const d = ctx.getImageData(0, 0, 64, 64).data;
    for (let i = 3; i < d.length; i += 4) if (d[i] < 250) return true;
    return false;
  }
  async function cabezalPlaceholder() {
    const img = new Image();
    img.src = BALL;
    await img.decode();
    const { url } = await fitImage(img, 'Cabezal');
    await setZoneTexture('Cabezal', url);
    const m = mat('Cabezal');
    if (m) originalTex.Cabezal = m.pbrMetallicRoughness.baseColorTexture.texture;
  }

  // corner example: a star, so it is clearly a different image from the centre symbol
  async function cornerPlaceholders() {
    const c = document.createElement('canvas');
    c.width = c.height = 400;
    const ctx = c.getContext('2d');
    ctx.beginPath();
    for (let i = 0; i < 10; i++) {
      const r = i % 2 ? 78 : 180, a = -Math.PI / 2 + (i * Math.PI) / 5;
      ctx.lineTo(200 + r * Math.cos(a), 210 + r * Math.sin(a));
    }
    ctx.closePath();
    ctx.lineJoin = 'round';
    ctx.lineWidth = 22; ctx.strokeStyle = '#1b1430'; ctx.stroke();
    ctx.fillStyle = '#c2448f'; ctx.fill();
    ctx.beginPath(); ctx.arc(160, 150, 22, 0, Math.PI * 2); ctx.fillStyle = 'rgba(255,255,255,.75)'; ctx.fill();
    for (const z of ['EsquinaIzq', 'EsquinaDer']) {
      const { url } = await fitImage(c, z);
      await setZoneTexture(z, url);
      const m = mat(z);
      if (m) originalTex[z] = m.pbrMetallicRoughness.baseColorTexture.texture;
    }
    refreshZone('EsquinaIzq'); refreshZone('EsquinaDer');
  }

  async function setZoneTexture(zone, url) {
    const m = mat(zone);
    if (!m) return;
    const tex = await mv.createTexture(url);
    m.pbrMetallicRoughness.baseColorTexture.setTexture(tex);
    m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, 1]);
  }
  const originalTex = {};
  function rememberOriginals() {
    Object.keys(ZONES).forEach((z) => {
      const m = mat(z);
      if (m) originalTex[z] = m.pbrMetallicRoughness.baseColorTexture.texture;
    });
  }
  function restoreZone(zone) {
    const m = mat(zone);
    if (!m) return;
    m.pbrMetallicRoughness.baseColorTexture.setTexture(originalTex[zone] || null);
    m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, 1]);
  }
  function setZoneVisible(zone, on) {
    const m = mat(zone);
    if (m) m.pbrMetallicRoughness.setBaseColorFactor([1, 1, 1, on ? 1 : 0]);
  }

  /* ---------- camera ---------- */
  const views = $$('.pkrm-bl__view');
  function setSpin(on) {
    if (on) mv.setAttribute('auto-rotate', ''); else mv.removeAttribute('auto-rotate');
    views.forEach((b) => { if (b.dataset.view === 'spin') { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); } });
  }
  function look(side, spin = false) {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraOrbit = side === 'back' ? '180deg 85deg auto' : '0deg 85deg auto';
    views.forEach((b) => b.dataset.view !== 'spin' && b.dataset.view !== 'home' && b.classList.toggle('is-on', b.dataset.view === side));
    setSpin(spin);
  }
  const HOME_ORBIT = mv.getAttribute('camera-orbit') || '25deg 82deg auto';
  function home() {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraTarget = 'auto auto auto';
    mv.fieldOfView = 'auto';
    mv.cameraOrbit = HOME_ORBIT;
    views.forEach((b) => b.dataset.view !== 'spin' && b.classList.remove('is-on'));
    setSpin(false);
  }
  views.forEach((b) => b.addEventListener('click', () => {
    if (b.dataset.view === 'spin') setSpin(!mv.hasAttribute('auto-rotate'));
    else if (b.dataset.view === 'home') home();
    else look(b.dataset.view);
  }));
  $$('[data-zone-focus]').forEach((fs) => fs.addEventListener('focusin', () => look(fs.dataset.zoneFocus)));

  /* ---------- body colour ---------- */
  const swWrap = $('[data-swatches]');
  const colorInput = $('[data-color-input]');
  function renderSwatches() {
    swWrap.innerHTML = '';
    (cfg.colors[state.line] || []).forEach((c) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pkrm-bl__sw' + (state.color && state.color.name === c.name && state.color.line === state.line ? ' is-on' : '');
      b.style.setProperty('--sw', c.hex);
      b.title = cname(c);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', cname(c));
      b.setAttribute('aria-checked', b.classList.contains('is-on'));
      b.addEventListener('click', () => pickColor({ ...c, line: state.line }));
      swWrap.appendChild(b);
    });
  }
  function pickColor(c) {
    state.color = c;
    $('[data-color-name]').textContent = `${cname(c)} (${c.line === 'PLA Matte' ? T.matte_s : T.gloss_s})`;
    colorInput.value = `${c.name} · Bambu ${c.line} · ${c.code}`;
    renderSwatches();
    applyColor();
    if (extrasBox) { extrasBox.style.setProperty('--extra-color', c.hex); }
    if (typeof syncExtras === 'function' && extrasColor) syncExtras();
  }
  function applyColor() {
    const m = mat('Cuerpo');
    if (!m || !state.color) return;
    m.pbrMetallicRoughness.setBaseColorFactor(state.color.hex);
    m.pbrMetallicRoughness.setRoughnessFactor(state.color.line === 'PLA Matte' ? 0.9 : 0.42);
  }
  $$('.pkrm-bl__tab').forEach((t) => t.addEventListener('click', () => {
    state.line = t.dataset.line;
    $$('.pkrm-bl__tab').forEach((x) => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t); });
    renderSwatches();
  }));

  /* ---------- uploads ---------- */
  const sameBox = $('[data-same-corners]');
  const rightCorner = $('[data-right-corner]');
  const cornerLabel = $('[data-corner-label]');
  const cornersMode = $('[data-corners-mode]');
  const leftInput = $('[data-upload="EsquinaIzq"] [data-file]');

  function syncCornerMode() {
    state.sameCorners = sameBox.checked;
    rightCorner.hidden = state.sameCorners;
    cornerLabel.textContent = state.sameCorners ? T.both_corners : T.left_corner;
    leftInput.name = state.sameCorners ? 'properties[Imagen esquinas]' : 'properties[Esquina izquierda]';
    cornersMode.value = state.sameCorners ? 'Misma imagen en las dos' : 'Una imagen distinta en cada esquina';
    refreshZone('EsquinaIzq');
    refreshZone('EsquinaDer');
  }
  sameBox.addEventListener('change', syncCornerMode);

  async function refreshZone(zone) {
    if (!state.ready) return;
    let file = state.uploads[zone];
    if (zone === 'EsquinaDer' && state.sameCorners) file = state.uploads.EsquinaIzq;
    if (!file) { restoreZone(zone); return; }
    const { url } = await fitImage(file, zone);
    await setZoneTexture(zone, url);
  }

  $$('[data-upload]').forEach((box) => {
    const zone = box.dataset.upload;
    const input = $('[data-file]', box);
    const label = $('[data-label]', box);
    const clear = $('[data-clear]', box);
    const drop = $('.pkrm-bl__drop', box);
    const reset = () => {
      input.value = '';
      delete state.uploads[zone];
      label.textContent = T.upload;
      drop.classList.remove('has-file');
      drop.style.removeProperty('--thumb');
      clear.hidden = true;
    };
    input.addEventListener('change', async () => {
      showError('');
      const file = input.files[0];
      if (!file) { reset(); refreshZone(zone); if (zone === 'EsquinaIzq') refreshZone('EsquinaDer'); return; }
      if (!(await isPng(file))) { reset(); showError(T.e_png); return; }
      if (file.size > cfg.maxBytes) { reset(); showError(T.e_big); return; }
      state.uploads[zone] = file;
      label.textContent = file.name.length > 26 ? file.name.slice(0, 23) + '…' : file.name;
      drop.classList.add('has-file');
      const thumb = URL.createObjectURL(file);
      drop.style.setProperty('--thumb', `url("${thumb}")`);
      clear.hidden = false;
      look(ZONES[zone].side);
      await refreshZone(zone);
      if (zone === 'EsquinaIzq') await refreshZone('EsquinaDer');
      if (zone === 'Trasera') { backAdjust.hidden = false; resetBackFit(); }
      if (zone === 'Cabezal') { headAdjust.hidden = false; }
      const { w, h } = await createImageBitmap(file).then((b) => ({ w: b.width, h: b.height }));
      const min = zone === 'Trasera' ? 1000 : 300;
      if (Math.max(w, h) < min) showError(fmt(T.e_low, { w, h, ideal: zone === 'Trasera' ? '1640 × 2330' : '800 × 800' }));
      else if (zone !== 'Trasera' && !(await hasTransparency(file))) showError(T.e_bg);
    });
    clear.addEventListener('click', () => { reset(); if (zone === 'Trasera') backAdjust.hidden = true; if (zone === 'Cabezal') { headAdjust.hidden = true; setHeadSize(100); } refreshZone(zone); if (zone === 'EsquinaIzq') refreshZone('EsquinaDer'); });
  });

  /* ---------- head symbol: size ---------- */
  const headAdjust = $('[data-head-adjust]');
  const headRange = $('[data-head-size]');
  const headInput = $('[data-head-input]');
  let headTimer;
  function setHeadSize(v) {
    state.headSize = +v;
    headRange.value = v;
    $('[data-head-out]').textContent = `${v}%`;
    headInput.value = `${v}%`;
    clearTimeout(headTimer);
    headTimer = setTimeout(() => refreshZone('Cabezal'), 50);
  }
  headRange.addEventListener('input', () => { look('front'); setHeadSize(headRange.value); });
  $('[data-head-reset]').addEventListener('click', () => { look('front'); setHeadSize(100); });

  /* ---------- back image: size & position ---------- */
  const backAdjust = $('[data-back-adjust]');
  const backFitInput = $('[data-back-fit-input]');
  const fitCtl = { zoom: $('[data-fit="zoom"]'), x: $('[data-fit="x"]'), y: $('[data-fit="y"]') };
  let fitTimer;
  function syncBackFit() {
    state.backFit = { zoom: +fitCtl.zoom.value, x: +fitCtl.x.value, y: +fitCtl.y.value };
    $('[data-fit-out="zoom"]').textContent = `${state.backFit.zoom}%`;
    const sign = (n) => (n > 0 ? '+' : '') + n;
    backFitInput.value = `Tamaño ${state.backFit.zoom}% · horizontal ${sign(state.backFit.x)}% · vertical ${sign(state.backFit.y)}%`;
    clearTimeout(fitTimer);
    fitTimer = setTimeout(() => refreshZone('Trasera'), 60);
  }
  function resetBackFit() {
    fitCtl.zoom.value = 100; fitCtl.x.value = 0; fitCtl.y.value = 0;
    syncBackFit();
  }
  Object.values(fitCtl).forEach((r) => r.addEventListener('input', () => { look('back'); syncBackFit(); }));
  $('[data-fit-reset]').addEventListener('click', () => { look('back'); resetBackFit(); });

  /* ---------- name ---------- */
  const nameInput = $('[data-name]');
  const fontSel = $('[data-font]');
  const tcWrap = $('[data-text-colors]');
  const tcInput = $('[data-text-color-input]');
  const outlineInput = $('[data-outline-input]');

  FONTS.forEach(([label, family, weight]) => {
    const o = document.createElement('option');
    o.value = label; o.textContent = label;
    o.style.fontFamily = `"${family}"`; o.style.fontWeight = weight;
    fontSel.appendChild(o);
  });
  function renderTextColors() {
    tcWrap.innerHTML = '';
    TEXT_COLORS.forEach((tc) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'pkrm-bl__sw' + (state.textColor[0] === tc[0] ? ' is-on' : '');
      b.style.setProperty('--sw', tc[1]);
      const tn = TC_NAMES[TEXT_COLORS.indexOf(tc)] || tc[0];
      b.title = tn;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', tn);
      b.setAttribute('aria-checked', state.textColor[0] === tc[0]);
      b.addEventListener('click', () => { state.textColor = tc; tcInput.value = `${tc[0]} ${tc[1]}`; renderTextColors(); drawName(); look('front'); });
      tcWrap.appendChild(b);
    });
  }

  let nameJob = 0;
  async function drawName() {
    if (!state.ready) return;
    const job = ++nameJob;
    const typed = state.name.trim();
    const text = typed || T.placeholder;   // example text until the customer types
    $('[data-count]').textContent = `${state.name.length}/12`;
    const [, family, weight] = FONTS.find((f) => f[0] === state.font);
    try { await document.fonts.load(`${weight} 120px "${family}"`, text); } catch (e) {}
    if (job !== nameJob) return;
    const z = ZONES.Nombre;
    const c = document.createElement('canvas');
    c.width = z.w; c.height = z.h;
    const ctx = c.getContext('2d');
    const slot = 1200, pad = 18, maxW = slot - pad * 2, maxH = z.h - pad * 2;
    let size = 220;
    const setFont = () => { ctx.font = `${weight} ${size}px "${family}", sans-serif`; };
    setFont();
    while (size > 20) {
      const mm = ctx.measureText(text);
      const h = (mm.actualBoundingBoxAscent || size * 0.75) + (mm.actualBoundingBoxDescent || 0);
      if (mm.width <= maxW && h <= maxH) break;
      size -= 4; setFont();
    }
    const mm = ctx.measureText(text);
    const asc = mm.actualBoundingBoxAscent || size * 0.75;
    const desc = mm.actualBoundingBoxDescent || 0;
    const y = z.h / 2 + (asc - desc) / 2;
    const align = { Izquierda: 'left', Centro: 'center', Derecha: 'right' }[state.namePos];
    const x = align === 'left' ? pad : align === 'center' ? z.w / 2 : z.w - pad;
    ctx.textAlign = align;
    ctx.lineJoin = 'round';
    if (state.outline !== 'Sin borde') {
      ctx.strokeStyle = state.outline === 'Negro' ? '#111111' : '#FFFFFF';
      ctx.lineWidth = Math.max(6, size * 0.12);
      ctx.strokeText(text, x, y);
    }
    ctx.fillStyle = state.textColor[1];
    ctx.fillText(text, x, y);
    const url = await canvasToUrl(c);
    if (job !== nameJob) return;
    await setZoneTexture('Nombre', url);
  }
  nameInput.addEventListener('input', () => { state.name = nameInput.value; drawName(); });
  nameInput.addEventListener('focus', () => look('front'));
  fontSel.addEventListener('change', () => { state.font = fontSel.value; drawName(); });
  const posInput = $('[data-pos-input]');
  $$('[data-seg]').forEach((seg) => {
    const btns = $$('button', seg);
    btns.forEach((b) => b.addEventListener('click', () => {
      btns.forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b); });
      if (seg.dataset.seg === 'pos') { state.namePos = b.dataset.val; posInput.value = b.dataset.val; }
      else { state.outline = b.dataset.val; outlineInput.value = b.dataset.val; }
      look('front'); drawName();
    }));
  });

  /* ---------- extras (variants) ---------- */
  const extrasBox = $('[data-extras]');
  const extrasColor = $('[data-extras-color]');
  const variantInput = $('input[name="id"]', form);
  const priceEl = $('[data-pkrm-price]');
  const money = (n) => new Intl.NumberFormat(EN ? 'en-IE' : 'es-ES', { style: 'currency', currency: 'EUR' }).format(n / 100);
  function syncExtras() {
    const sop = $('[data-extra="soporte"]').checked, gan = $('[data-extra="gancho"]').checked;
    // variant order: Sin extras, Con soporte, Con gancho de nevera, Con soporte y gancho
    const v = (cfg.variants || [])[(sop ? 1 : 0) + (gan ? 2 : 0)] || (cfg.variants || [])[0];
    if (v) {
      variantInput.value = v.id;
      priceEl.textContent = money(v.price);
      buyLabel = `${T.add} · ${money(v.price)}`;
      if (!buy.disabled) buy.textContent = buyLabel;
    }
    extrasColor.disabled = !(sop || gan);
    extrasColor.value = state.color ? `${state.color.name} · Bambu ${state.color.line} · ${state.color.code} (igual que la Booster Lite)` : '';
  }
  $$('[data-extra]').forEach((c) => c.addEventListener('change', syncExtras));
  const zoomDlg = $('[data-zoom-dialog]');
  $$('[data-zoom]').forEach((img) => img.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!zoomDlg || !zoomDlg.showModal) return;
    const big = $('img', zoomDlg);
    big.src = img.currentSrc || img.src; big.alt = img.alt;
    zoomDlg.showModal();
  }));
  if (zoomDlg) {
    $('[data-zoom-close]', zoomDlg).addEventListener('click', () => zoomDlg.close());
    zoomDlg.addEventListener('click', (e) => { if (e.target === zoomDlg) zoomDlg.close(); });
  }

  /* ---------- order preview + submit ---------- */
  async function snapshot(side) {
    if (mv.resetTurntableRotation) mv.resetTurntableRotation(0);
    mv.cameraOrbit = side === 'back' ? '180deg 85deg auto' : '0deg 85deg auto';
    mv.jumpCameraToGoal();
    await nextFrame(); await nextFrame();
    return createImageBitmap(await mv.toBlob({ mimeType: 'image/png', idealAspect: true }));
  }
  async function buildPreview() {
    const wasSpinning = mv.hasAttribute('auto-rotate');
    setSpin(false);
    // hide example placeholders: the preview must show only what will be printed
    const empty = [];
    ['Trasera', 'Cabezal', 'EsquinaIzq', 'EsquinaDer'].forEach((z) => {
      const has = z === 'EsquinaDer' && state.sameCorners ? state.uploads.EsquinaIzq : state.uploads[z];
      if (!has) { setZoneVisible(z, false); empty.push(z); }
    });
    if (!state.name.trim()) { setZoneVisible('Nombre', false); empty.push('Nombre'); }
    const front = await snapshot('front');
    const back = await snapshot('back');
    empty.forEach((z) => setZoneVisible(z, true));
    look('front', wasSpinning);
    const c = document.createElement('canvas');
    c.width = front.width + back.width; c.height = Math.max(front.height, back.height);
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(front, 0, 0); ctx.drawImage(back, front.width, 0);
    return new Promise((res) => c.toBlob(res, 'image/png'));
  }

  const buy = $('[data-buy]');
  let buyLabel = buy.textContent.trim();
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');
    if (!state.color) { showError(T.e_color); return; }
    const hasUpload = Object.keys(state.uploads).length > 0;
    const rights = $('[data-rights]');
    if ((hasUpload || state.name.trim()) && !rights.checked) { showError(T.e_rights); rights.focus(); return; }
    buy.disabled = true; buy.textContent = T.preparing;
    try {
      const pf = $('[data-preview-file]');
      try {
        const blob = await buildPreview();
        const dt = new DataTransfer();
        dt.items.add(new File([blob], 'vista-previa-booster-lite.png', { type: 'image/png' }));
        pf.files = dt.files;
        pf.disabled = false;
      } catch (e2) { pf.disabled = true; }
      // don't send empty fields
      $$('[data-file]').forEach((i) => { i.disabled = !i.files || !i.files.length; });
      if (state.sameCorners) $('[data-upload="EsquinaDer"] [data-file]').disabled = true;
      const nameOn = !!state.name.trim();
      [fontSel, tcInput, outlineInput, posInput].forEach((i) => { i.disabled = !nameOn; });
      nameInput.disabled = !nameOn;
      cornersMode.disabled = !state.uploads.EsquinaIzq && !state.uploads.EsquinaDer;
      backFitInput.disabled = !state.uploads.Trasera;
      headInput.disabled = !state.uploads.Cabezal;
      HTMLFormElement.prototype.submit.call(form);
    } catch (e3) {
      buy.disabled = false; buy.textContent = buyLabel;
      showError(T.e_fail);
    }
  });
  // re-enable fields if the user comes back with the browser "back" button
  window.addEventListener('pageshow', () => {
    $$('input, select', form).forEach((i) => { if (!i.hasAttribute('data-keep-disabled')) i.disabled = false; });
    syncExtras();
    buy.disabled = false; buy.textContent = buyLabel;
  });

  /* ---------- init ---------- */
  renderTextColors();
  syncCornerMode();
  tcInput.value = `${state.textColor[0]} ${state.textColor[1]}`;
  const all = Object.values(cfg.colors).flatMap((arr, i) => arr.map((c) => ({ ...c, line: Object.keys(cfg.colors)[i] })));
  const def = all.find((c) => c.name === cfg.defaultColor) || all[0];
  state.line = def.line;
  $$('.pkrm-bl__tab').forEach((x) => { const on = x.dataset.line === state.line; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
  pickColor(def);

  const onLoad = () => {
    if (!mat('Cuerpo')) return;   // ignore loads without our model (e.g. empty src)
    state.ready = true;
    rememberOriginals();
    if (!state.uploads.Cabezal) cabezalPlaceholder();
    cornerPlaceholders();
    applyColor();
    drawName();
    Object.keys(state.uploads).forEach(refreshZone);
    root.classList.add('is-ready');
    window.__pkrmBL = { mv, state, ready: true };
  };
  mv.addEventListener('load', onLoad);
  if (mv.loaded) onLoad();
  mv.addEventListener('progress', (e) => { const p = $('[data-pkrm-progress]'); if (p) p.hidden = e.detail.totalProgress >= 1; });
  mv.addEventListener('pointerdown', () => setSpin(false), { passive: true });
})();
